import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Head from 'next/head';
import Footer from '@/components/common/widgets/Footer';
import HeroSection from '@/components/homepage/HeroSection';
import Layout from '@/components/common/layouts/Layout';
import IntroSection from './aboutpage/IntroSection';
import CarouselSection from './aboutpage/CarouselSection';
import IconSection from './aboutpage/IconSection';
import ActionSection from './aboutpage/ActionSection';
import Grid1Section from './aboutpage/Grid1Section';
import Grid2Section from './aboutpage/Grid2Section';

function About() {
  return (
    <Layout>
      <Head>
        <title>Big & Mini: About Us</title>
        <meta name="description" content="All about Big & Mini: who we are, what we do, where we are from." />
      </Head>
      <div id="about">
        <ParallaxProvider>
          <HeroSection
            image="/images/ab_6.jpg"
                // image = "/images/teamphotos/IMG_4463.PNG"
            alt="Elderly woman next to red flowers"
            topSpace={(
              <div>
                <br />
              </div>
                )}
            title="About Us"
            description={"Let's create something amazing"}
            otherContent=""
          />
        </ParallaxProvider>
        <IntroSection />
        <CarouselSection />
        <IconSection />
        <Grid1Section image="/images/img_9.jpg" />
        <Grid2Section />

        <ActionSection />
        <Footer />
      </div>
    </Layout>
  );
}

export default About;
